import React, { useEffect, useState } from "react";
import { Button, Typography, Grid, Card, CardContent } from "@mui/material";
import { useLanguageContext } from "../../../Context/LanguageContext";
export default function ShowEquipmentStatus({
  isInspectionRequired,
  mandatory,
  counts,
  setIsEquipmentNioOrIo,
  setIsEquipmentNio,
  nonMandatory,
}) {
  const { localization } = useLanguageContext();
  const [selectedButton, setSelectedButton] = useState("");
  useEffect(() => {
    setIsEquipmentNio(
      isInspectionRequired.isCheckListCritical &&
        counts["noCriticalIssue"] !== 0
        ? Object.keys(mandatory).length > 0 || Object.keys(nonMandatory).length
          ? true
          : false
        : false
    );
  }, []);
  return (
    isInspectionRequired.isCheckListCritical && (
      <React.Fragment>
        {counts["noCriticalIssue"] === 0 ? (
          <Card variant="elevation" elevation={3}>
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm="auto">
                  <Typography variant="h6">
                    <span className="errorCls">*</span>
                    {localization.equipmentStatusHeader}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm="auto">
                  <Button
                    variant="contained"
                    className={`buttonRounded mr-5 
                 ${selectedButton === "nio" ? "selectButtonyes" : ""}
                  `}
                    onClick={() => {
                      setSelectedButton("nio");
                      setIsEquipmentNioOrIo("NIO");
                      setIsEquipmentNio(true);
                    }}
                  >
                    {localization.nio}
                  </Button>
                  <Button
                    variant="contained"
                    className={`buttonRounded   ${
                      selectedButton === "in" ? "selectButton" : ""
                    }`}
                    onClick={() => {
                      setSelectedButton("in");
                      setIsEquipmentNioOrIo("IN");
                      setIsEquipmentNio(false);
                    }}
                  >
                    {localization.io}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Card variant="elevation" elevation={3}>
            <CardContent>
              {Object.keys(mandatory).length > 0 ||
              Object.keys(nonMandatory).length > 0 ? (
                <Typography variant="h6" color="error">
                  {localization.equipmentNio}
                </Typography>
              ) : (
                <Typography variant="h6">{localization.equipmentIo}</Typography>
              )}
            </CardContent>
          </Card>
          // ))
        )}
      </React.Fragment>
    )
  );
}
